export const isMobileDevice = () => /Mobi|Android/i.test(navigator.userAgent);

export const isScreenWidth = (width) => matchMedia(`(max-width: ${width}px)`).matches